import React, { useEffect, useState } from "react";
import { Card, Spinner, Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { IoMdStar } from "react-icons/io";
import "../App.css";
import { IoMdSettings } from "react-icons/io";
import { FaArchive, FaArrowRight } from "react-icons/fa";
import "../Styles/ModulePage.css";
import ModuleAccessSummary from "./ModuleAccessSummary";
// import { TbBackground } from "react-icons/tb";

const CardItem = ({
  image,
  title,
  subtitle,
  buttonText,
  onButtonClick,
  onArchiveClick,
  userRole,
  allowedUserCount,
  allowedUserNames,
}) => (
  <Card className="module-card">
    <div className="module-card__media">
      <Card.Img variant="top" src={image} className="module-card__image" />
      <span className="module-card__badge module-card__badge--featured">Featured</span>
      {userRole === "admin" && (
        <Dropdown
          className="position-absolute"
          style={{ top: "10px", right: "10px" }}
        >
          <Dropdown.Toggle
            variant="light"
            id={`starred-module-menu-${title}`}
            className="module-card__menu-button"
            aria-label={`Actions for ${title}`}
          >
            <IoMdSettings size={20} />
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item onClick={onArchiveClick}>
              <FaArchive /> &nbsp; Archive
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      )}
    </div>
    <Card.Body className="module-card__body">
      <div className="module-card__title-row">
        <Card.Title className="module-card__title">{title}</Card.Title>
        <IoMdStar size={19} className="module-card__star" aria-label="Starred" />
      </div>
      <Card.Subtitle className="module-card__subtitle">
        {subtitle}
      </Card.Subtitle>
      {userRole === "admin" && (
        <ModuleAccessSummary count={allowedUserCount} names={allowedUserNames} />
      )}
      <button
        className="module-card__button"
        onClick={onButtonClick}
      >
        <span>{buttonText}</span><FaArrowRight aria-hidden="true" />
      </button>
    </Card.Body>
  </Card>
);

function Modules() {
  const navigate = useNavigate();
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userRole, setUserRole] = useState("");

  useEffect(() => {
    const loggedInUser = JSON.parse(localStorage.getItem("user"));
    if (loggedInUser && loggedInUser.user_role) {
      setUserRole(loggedInUser.user_role);
    }
  }, []);

  useEffect(() => {
    const fetchModules = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user"));

        if (!user || !user.user_id) {
          console.error("User not found or user ID missing in localStorage");
          setLoading(false);
          return;
        }

        const userId = user.user_id;

        const response = await fetch(
          `${process.env.REACT_APP_API}/getStarModule?user_id=${userId}`,
        );

        const data = await response.json();

        if (data.success) {
          setModules(data.data);
        } else {
          console.error("Error fetching modules:", data.message);
        }
      } catch (error) {
        console.error("Error fetching modules:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchModules();
  }, []);

  const handleAssessmentClick = (moduleId, moduleName) => {
    navigate("/assessmentpage", { state: { moduleId, moduleName } });
  };

  const handleArchive = async (moduleId) => {
    const confirm = window.confirm(
      "Are you sure you want to archive this module?",
    );
    if (!confirm) return;

    try {
      const response = await fetch(`${process.env.REACT_APP_API}/setArchive`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ module_id: moduleId }),
      });

      const data = await response.json();

      if (data.success) {
        console.log("Archived successfully!");
        // Remove from UI
        setModules((prev) => prev.filter((m) => m.module_id !== moduleId));
      } else {
        console.error("Failed to archive:", data.message);
      }
    } catch (error) {
      console.error("Error archiving module:", error);
    }
  };

  if (loading) {
    return (
      <div className="module-grid__state">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <div className="module-grid">
        {modules.map((module) => (
          <div key={module.module_id}>
            <CardItem
              image="https://images.unsplash.com/photo-1488375634201-b85b28653a79?q=80&w=2029&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              title={module.module_name}
              subtitle={module.description}
              buttonText="Learn More"
              onButtonClick={() =>
                handleAssessmentClick(module.module_id, module.module_name)
              }
              onArchiveClick={() => handleArchive(module.module_id)}
              userRole={userRole}
              allowedUserCount={module.allowed_user_count}
              allowedUserNames={module.allowed_user_names}
            />
          </div>
        ))}
        {modules.length === 0 && <div className="module-grid__empty">No starred modules yet.</div>}
    </div>
  );
}

export default Modules;
